import {Injectable} from '@angular/core';
import {ApiService} from "@core/shared/services/api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable} from "rxjs";
import {Pagination} from "@core/shared/models/pagination";
import {RegistrationAffiliation} from "@core/shared/models/registration-affiliation";

@Injectable({
    providedIn: 'root'
})
export class RegistrationAffiliationService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public getItemsAPI(params?: string[]): Observable<RegistrationAffiliation[]> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/registrationAffiliations`;

        params = params || [];

        params.push('disablePagination=1');

        if (params.length > 0) {

            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<RegistrationAffiliation[]>(url, {
            headers: headers
        });
    }

    public getPaginationItemsAPI(params?: string[]): Observable<Pagination<RegistrationAffiliation>> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/registrationAffiliations`;

        params = params || [];

        if (params.length > 0) {
            url = `${url}?${params.join('&')}`;
        }

        return this._httpClient.get<Pagination<RegistrationAffiliation>>(url, {
            headers: headers
        });
    }

    public getItemAPI(id: number, params?: string[]): Observable<RegistrationAffiliation> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        let url: string = `${this._apiService.getApiUrl(false, true)}/registrationAffiliations/${id}`;

        if (!!params && params.length > 0) {

            url = `${url}?${params}`;
        }

        return this._httpClient.get<RegistrationAffiliation>(url, {
            headers: headers
        });
    }

    public createItemAPI(data: object): Observable<RegistrationAffiliation> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.post<RegistrationAffiliation>(`${this._apiService.getApiUrl(false, true)}/registrationAffiliations`, data, {
            headers: headers
        });
    }

    public updateItemAPI(id: number, data: object): Observable<RegistrationAffiliation> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.patch<RegistrationAffiliation>(`${this._apiService.getApiUrl(false, true)}/registrationAffiliations/${id}`, data, {
            headers: headers
        });
    }

    public deleteItemAPI(id: number): Observable<void> {

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json');

        return this._httpClient.delete<void>(`${this._apiService.getApiUrl(false, true)}/registrationAffiliations/${id}`, {
            headers: headers
        });
    }
}